export const CONFIG = {
  CDN_BASE: 'https://cdnsonata.taptapnetworks.com/assets/images'
};
